<!DOCTYPE html>
<html lang="en">

<head>
    <meta charset="UTF-8">
    <meta http-equiv="X-UA-Compatible" content="IE=edge">
    <meta name="viewport" content="width=device-width, initial-scale=1.0">
    <title>Document</title>
</head>

<body>

    <app-header></app-header>
    <section id="hero" class="hero_slide cust-hero-slider">
        <div data-bs-interval="5000" class="" data-bs-ride="carousel">

            <div class="container">
                <div class="row">
                    <div class="col-lg-6 col-md-6 mt-3 cust-slider-left-text pad_top_30">
                        <h2 class="animate__animated animate__fadeInDown text-alignment-center">Contact</h2>
                        <p class="animate__animated animate__fadeInUp width-100 m-0 text_jus1 pb-3">Any Questions?<br />
                            Feel free to reach out to us.<br>We will reply back you in 24 hours.</p>


                    </div>
                    <div class="col-lg-6 col-md-6 text-right">
                        <img src="assets/images/amico.svg" class="slider-img-level slider-img">
                    </div>
                </div>


            </div>
        </div>
    </section>

    <main id="main">

        <section id="clients" class="clients">
            <div class="container p-0">


                <div class="row client-logo-main">

                    <div
                        class="col-lg-2 col-md-4 col-2 d-flex align-items-center justify-content-center cust-padding-7">
                        <img src="assets/img/Adani-power-logo.svg" class="img-fluid" alt="">
                    </div>

                    <div
                        class="col-lg-2 col-md-4 col-2 d-flex align-items-center justify-content-center cust-padding-7">
                        <img src="assets/img/Cognitive Technologies.svg" class="img-fluid" alt="">
                    </div>

                    <div
                        class="col-lg-2 col-md-4 col-2 d-flex align-items-center justify-content-center cust-padding-7">
                        <img src="assets/img/Anodyne Technologies.svg" class="img-fluid" alt="">
                    </div>

                    <div
                        class="col-lg-2 col-md-4 col-2 d-flex align-items-center justify-content-center cust-padding-7">
                        <img src="assets/img/Energy Doctor (Tricolite Energy Soln).svg" class="img-fluid" alt="">
                    </div>

                    <div
                        class="col-lg-2 col-md-4 col-2 d-flex align-items-center justify-content-center cust-padding-7">
                        <img src="assets/img/Navi mumbai corporation.svg" class="img-fluid" alt="">
                    </div>

                    <div
                        class="col-lg-2 col-md-4 col-2 d-flex align-items-center justify-content-center cust-padding-7">
                        <img src="assets/img/rech.svg" class="img-fluid" alt="">
                    </div>

                </div>

            </div>
        </section>


        <section id="flex-container" class="testimonials pad-top-70 pad-bottom-40">

            <div class="container pad-top pb-5 pt-3">
                <div class="left_half pad-top pad_left_50">


                    <p class="contact_heading pad_bot_21">Let’s Chat.<br class="text_hide1" />
                        Tell me About Your<br class="text_hide1" />

                        Requirement.</p>

                    <div class="resp_flex pad_bot_21">
                        <p class="margin-0 font-black pt-1 pb-3">Let’s Create Something Together <img
                                src="assets/img/hand_winner_img.png" class="link-img-linkdin margin-right-5 link-img">
                        </p>
                    </div>



                    <div class="container_mail resp_flex pad_bot_21">

                        <div class="pt-1"><img src="assets/img/mail_img.png" class="mail-img-linkdin margin-right-5">
                        </div>

                        <div style="padding-top: 7px;">
                            <p class="mail_heading_text" style="margin-bottom: 0 !important;">Mail me at</p>
                            <p class="mail_content_text">sales@samyak.com
                            </p>
                        </div>


                    </div>

                </div>

                <div class="right_half">

                    <div>

                        <div class="text_center pad_left pad_bot_21">
                            <p class="message_text">Send us a Message</p>
                        </div>




                        <div class="pb-4 text_center">
                            <input type="text" placeholder="Full Name*" name="name"
                                class="contact_input_space placeholder_text" #box (keyup)="getValue(box.value)" />
                        </div>



                        <div class="pb-4 text_center">
                            <input type="text" placeholder="Email Address*" name="Email"
                                class="contact_input_space placeholder_text" #box (keyup)="getValue(box.value)" />
                        </div>



                        <div class="pb-4 text_center">
                            <input type="text" placeholder="Subject*" name="subject"
                                class="contact_input_space placeholder_text" #box (keyup)="getValue(box.value)" />
                        </div>


                        <div class="text_center">
                            <p class="message_text">Tell me Any Questions? Drop us a message! </p>
                        </div>



                        <div class="pb-4 text_center">
                            <input type="text" placeholder="Message*" name="message"
                                class="contact_input_space_textArea placeholder_text" #box
                                (keyup)="getValue(box.value)" />
                        </div>


                        <div class="text_center"> <button mat-button color="primary"
                                class="contact_button1 font-white button_text" style="width: 125px; height: 35px;">Send
                                Message</button></div>

                    </div>


                </div>






            </div>
        </section>

    </main>


    <app-footer></app-footer>



</body>

</html>